import _PerfectScrollbar from "react-perfect-scrollbar";

export const PerfectScrollbar = _PerfectScrollbar;
